<template>
  <div class="banner_warp">
    <div class="banner left_animation_action">
      <div class="title">思勃咨询</div>
      <div class="sub_title">专注中国网络购物市场的研究和分析</div>
      <div class="content">
        运用自行研发的监测系统和特有的研究方法进行产品精准抓取，编码，<br />为客户提供各品类深度分析
      </div>
    </div>
  </div>
  <div class="channel_wrap">
    <div class="wrap">
      <div class="img_wrap">
        <img
          src="../assets/imgs/channel.png"
          :class="[animalIndex > 0 ? 'left_animation_action' : '']"
          alt=""
        />
      </div>
      <div class="content">
        <div class="title">
          监测渠道
          <div class="sub_title">Channel Coverage</div>
        </div>
        <div class="des point">
          <span>覆盖几乎主流B2C和C2C等传统电商网站</span>
        </div>
        <div class="des point">
          <span>覆盖时下热门社交电商，短视频及O2O平台等</span>
        </div>
        <div class="line"></div>
        <div class="tabs">
          <div
            class="tab"
            v-for="(tab, index) of tabs"
            :key="index"
            @mouseenter="handleTab(tab)"
            :class="[tab.checked ? 'active' : '']"
          >
            {{ tab.lable }}
          </div>
        </div>

        <div class="platform_list" v-if="tabs[0].checked">
          <img src="../assets/imgs/taobao_logo.png" alt="" />
          <img src="../assets/imgs/tmall_logo.png" alt="" />
          <img src="../assets/imgs/jd_logo.png" alt="" />
          <img src="../assets/imgs/kaola_logo.png" alt="" />
          <img src="../assets/imgs/wph_logo.png" alt="" />
        </div>
        <div class="platform_list" v-else-if="tabs[1].checked">
          <img src="../assets/imgs/pdd_logo.png" alt="" />
          <img src="../assets/imgs/wechat_logo.png" alt="" />
        </div>
        <div class="platform_list" v-else-if="tabs[2].checked">
          <img src="../assets/imgs/dy_logo.png" alt="" />
          <img src="../assets/imgs/ks_logo.png" alt="" />
        </div>
        <div class="platform_list" v-else-if="tabs[3].checked">
          <img src="../assets/imgs/tbzb_logo.png" alt="" />
        </div>
        <div class="platform_list" v-else-if="tabs[4].checked">
          <img src="../assets/imgs/txd_logo.png" alt="" />
          <img src="../assets/imgs/meituan_logo.png" alt="" />
          <img src="../assets/imgs/hema_logo.png" alt="" />
        </div>
      </div>
    </div>
  </div>
  <div class="dimension_wrap">
    <div class="wrap">
      <div class="content">
        <div class="title">
          数据维度
          <div class="sub_title">Data Dimension</div>
        </div>
        <div class="des">
          各品类的深度分析，包括市场规模，细分市场，增长速度，品牌份额
        </div>
        <div class="des">及单品爆款等市场各方面的表现</div>
        <div class="list">
          <div class="item" v-for="(item, index) of dimensionList" :key="index">
            <img
              :src="require(`../assets/imgs/dimension_item_${index + 1}.png`)"
              alt=""
            />
            <br />
            <div>{{ item }}</div>
          </div>
        </div>
      </div>
      <div class="img_wrap">
        <img
          src="../assets/imgs/dimension.png"
          :class="[animalIndex > 1 ? 'right_animation_action' : '']"
          alt=""
        />
      </div>
    </div>
  </div>
  <div class="report_wrap">
    <div class="wrap">
      <div class="img_wrap">
        <img
          src="../assets/imgs/report.png"
          :class="[animalIndex > 2 ? 'left_animation_action' : '']"
          alt=""
        />
      </div>
      <div class="content">
        <div class="title">
          报告时间
          <div class="sub_title">Reporting Frequency</div>
        </div>
        <div class="des point">
          <span>按需定制化监测报告时间</span>
        </div>
        <div class="des point">
          <span>满足客户报告读取及市场分析频率的需求</span>
        </div>
        <div class="des point">
          <span>精准把握市场变化脉搏</span>
        </div>
        <div class="line"></div>
        <div class="list">
          <div class="item" v-for="(item, index) of reportList" :key="index">
            <div class="img">
              <img
                :src="require(`../assets/imgs/report_item_${index + 1}.png`)"
                alt=""
              />
            </div>
            <div>{{ item }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="monitoring_wrap">
    <div class="wrap">
      <div class="content">
        <div class="title">
          市场追踪
          <div class="sub_title">Online Market Monitoring</div>
        </div>
        <div class="des">
          全品类追踪，监测行业包括母婴、美妆护肤、百货食品、口腔护理、
        </div>
        <div class="des">医药保健、居家用品和酒水饮料等及其子行业</div>
        <div class="list">
          <div
            class="item"
            v-for="(item, index) of monitoringList"
            :key="index"
          >
            <div class="img">
              <img
                :src="require(`../assets/imgs/monitor_item_${index + 1}.png`)"
                alt=""
              />
            </div>
            <div>{{ item.name }}</div>
            <div class="hover">
              <!-- <div
                class="sub_name"
                v-for="(name, ind) of item.children"
                :key="ind"
              >
                -{{ name }}-
              </div> -->
              <div v-if="item.children.length === 0" class="more">
                <div class="msg">获取更多网购市场内容请联系我们</div>
                <div class="button" @click="showModal">马上联系</div>
              </div>
              <div v-else class="more">
                <div class="button" @click="showModal">马上联系</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="overview_wrap">
    <div class="wrap">
      <div class="content">
        <div class="title">
          中国网购市场整体概览
          <div class="sub_title">China Online Market Overview</div>
        </div>
        <Slider
          :data="[
            'overview_item_1.png',
            'overview_item_2.png',
            'overview_item_3.png',
          ]"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { ref } from "@vue/reactivity";
import { onMounted } from "@vue/runtime-core";
import Slider from "@/components/SelfSlider.vue";
export default {
  components: {
    Slider,
  },
  setup() {
    const animalIndex = ref<number>(0);
    const tabs = ref<any>([
      {
        lable: "传统电商",
        checked: true,
      },
      {
        lable: "社交电商",
        checked: false,
      },
      {
        lable: "短视频",
        checked: false,
      },
      {
        lable: "直播",
        checked: false,
      },
      {
        lable: "O2O",
        checked: false,
      },
    ]);
    const dimensionList = ref([
      "市场规模",
      "品牌表现",
      "产品系列",
      "单品爆款",
      "销售额",
      "销售量",
      "市场份额",
      "价格变化",
    ]);

    const reportList = ref(["每月报告", "每季报告", "每年报告"]);

    const monitoringList = ref([
      {
        name: "母婴",
        children: [
          "婴幼儿奶粉",
          "儿童食品",
          "纸尿裤",
          "孕妇营养品",
          "儿童护理",
          "玩具",
        ],
      },
      {
        name: "美妆",
        children: [
          "彩妆",
          "护肤品",
          "头发护理",
          "身体护理",
          "香水",
          "美容仪器",
        ],
      },
      {
        name: "百货食品",
        children: ["面粉", "食用油", "巧克力", "糖果", "饼干", "鸡精"],
      },
      {
        name: "口腔护理",
        children: ["牙膏", "牙刷", "水牙线", "电动牙刷", "牙线", "牙粉"],
      },
      {
        name: "医药保健",
        children: [
          "鱼油",
          "维生素",
          "益生菌",
          "药用洗发水",
          "肠胃用药",
          "眼科用药",
        ],
      },
      {
        name: "居家用品",
        children: [
          "滤水设备",
          "织物护理",
          "消毒湿巾",
          "驱虫驱蚊",
          "地板清洁",
          "厨房清洁",
        ],
      },
      {
        name: "酒水饮料",
        children: ["洋酒", "葡萄酒", "啤酒", "白奶", "即饮茶", "含乳饮料"],
      },
      {
        name: "更多...",
        children: [],
      },
    ]);
    const handleTab = (tab: any) => {
      tabs.value.forEach((item: any) => {
        item.checked = item.lable === tab.lable ? true : false;
      });
    };

    onMounted(() => {
      window.addEventListener("scroll", () => {
        const top =
          document.documentElement.scrollTop || document.body.scrollTop;
        if (top > 10) {
          animalIndex.value = animalIndex.value > 0 ? animalIndex.value : 1;
        }
        if (top > 620) {
          animalIndex.value = animalIndex.value > 1 ? animalIndex.value : 2;
        }
        if (top > 1244) {
          animalIndex.value = 3;
        }
      });
    });
    const showModal = () => {
      document.dispatchEvent(new CustomEvent("show_modal", { detail: 1 }));
    };
    return {
      animalIndex,
      tabs,
      handleTab,
      dimensionList,
      reportList,
      monitoringList,
      showModal,
    };
  },
};
</script>
<style lang="less" scoped>
@keyframes leftMove {
  from {
    transform: translateX(-300px);
  }
  to {
    transform: translateX(0px);
    opacity: 1;
  }
}
@keyframes rightMove {
  from {
    transform: translateX(300px);
  }
  to {
    transform: translateX(0px);
    opacity: 1;
  }
}

.left_animation_action {
  animation: leftMove 1s;
  animation-fill-mode: forwards;
}
.right_animation_action {
  animation: rightMove 1s;
  animation-fill-mode: forwards;
}

.banner_warp {
  min-width: 1200px;
  height: 620px;
  margin: 0 auto;
  background: url(../assets/imgs/home_banner.png);
  .banner {
    width: 1200px;
    margin: 0 auto;
    transform: translateX(-300px);
    opacity: 0;
    .title {
      padding-top: 100px;
      font-size: 40px;
      color: #fff;
    }
    .sub_title {
      margin-top: 20px;
      font-size: 44px;
      color: #fff;
      background: linear-gradient(
        to right,
        rgba(91, 62, 247, 0.3),
        rgba(36, 124, 224, 0.3)
      );
      display: inline-block;
      padding-right: 4px;
    }
    .content {
      margin-top: 40px;
      font-size: 24px;
      color: #fff;
      font-weight: lighter;
      line-height:36px;
      letter-spacing: 2px;
    }
  }
}

.wrap {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  .img_wrap {
    position: relative;
    &::before {
      content: "";
      position: absolute;
      background: url(../assets/imgs/img_back.png) no-repeat;
      width: 896px;
      height: 372px;
    }
    img {
      height: 480px;
      position: relative;
      z-index: 1;
    }
  }
  .content {
    .title {
      color: #2c2d3f;
      font-weight: bold;
      font-size: 32px;
      .sub_title {
        font-size: 16px;
        color: #8392a5;
        font-weight: normal;
        padding: 10px 0;
      }
    }
    .des {
      color: #596675;
      font-size: 16px;
      margin-top: 10px;
      display: flex;
      align-items: center;
      // font-weight: bold;
      &.point::before {
        content: "";
        border: 2px solid #0072bd;
        border-radius: 4px;
        margin-right: 10px;
      }
    }
    .line {
      width: 260px;
      margin-top: 30px;
      border-top: 2px solid #d8dfe5;
    }
  }
}
.channel_wrap {
  height: 624px;
  min-width: 1200px;
  background: #fff;
  .wrap {
    padding-top: 94px;
    .img_wrap {
      img {
        transform: translateX(-300px);
        opacity: 0;
      }
      &::before {
        left: -265px;
        bottom: 10px;
      }
    }
    .content {
      padding-top: 20px;
      .tabs {
        display: flex;
        margin-top: 30px;
        align-items: center;
        margin-left: -10px;
        margin-bottom: 28px;
        .tab {
          margin: 10px;
          background: #f0f3f7;
          color: #8392a5;
          padding: 6px 0;
          width: 96px;
          font-size: 16px;
          text-align: center;
          font-weight: bold;
          cursor: pointer;
          &.active {
            border-bottom: 3px solid #0072bd;
            padding-bottom: 3px;
            color: #2c2d3f;
          }
        }
      }
      .platform_list {
        img {
          margin-right: 30px;
          width: 64px;
        }
      }
    }
  }
}
.dimension_wrap {
  min-width: 1200px;
  height: 624px;
  .wrap {
    padding-top: 74px;
    .img_wrap {
      img {
        transform: translateX(300px);
        opacity: 0;
      }
      &::before {
        right: -200px;
        bottom: -20px;
      }
    }
    .content {
      margin-top: 30px;
      .list {
        display: flex;
        align-items: center;
        width: 520px;
        flex-wrap: wrap;
        .item {
          text-align: center;
          margin-right: 60px;
          width: 70px;
          margin-top: 30px;
          margin-bottom: 8px;
          font-size: 16px;
          color: #596675;
          img {
            width: 56px;
            margin-bottom: 6px;
          }
        }
      }
    }
  }
}
.report_wrap {
  min-width: 1200px;
  height: 590px;
  background: #fff;
  .wrap {
    padding-top: 74px;
    .img_wrap {
      img {
        transform: translateX(-300px);
        opacity: 0;
      }
      &::before {
        left: -216px;
        bottom: 20px;
      }
    }
    .content {
      margin-top: 30px;
      .list {
        display: flex;
        align-items: center;
        margin-top: 18px;
        width: 360px;
        justify-content: space-between;
        margin-right: 40px;
        .item {
          text-align: center;
          margin-top: 30px;
          font-size: 16px;
          color: #596675;
          .img {
            margin-bottom: 20px;
            padding: 12px;
            background: #f2f9ff;
            border: 6px solid #fff;
            box-shadow: 0px 0px 12px 1px #e6ebed;
            border-radius: 36px;
            font-size: 0px;
            transition: 0.5s all;
            &:hover {
              background: #437acf;
              border-color: #437acf;
              img {
                filter: grayscale(100%) brightness(300%);
              }
            }
          }
        }
      }
    }
  }
}
.monitoring_wrap {
  min-width: 1200px;
  height: 848px;
  .wrap {
    padding-top: 86px;
    position: relative;
    .content {
      width: 100%;
      text-align: center;
      position: relative;
      z-index: 1;
      .des {
        justify-content: center;
      }
      .list {
        padding: 62px 34px 0 34px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
        .item {
          width: 258px;
          height: 224px;
          border-radius: 8px;
          box-shadow: 0 0 16px 2px #e6ebed;
          background: #fff;
          margin-bottom: 34px;
          color: #596675;
          font-size: 18px;
          font-weight: bold;
          overflow: hidden;
          position: relative;
          .img {
            margin: 32px 0px;
            font-size: 0;
          }
          .hover {
            transition: 0.6s all;
            width: 100%;
            height: 224px;
            background: #437acf;
            color: #fff;
            font-size: 14px;
            position: absolute;
            top: 224px;
            left: 0px;
            font-weight: lighter;
            padding-top: 10px;
            .sub_name {
              margin-top: 13px;
              letter-spacing: 2px;
              position: relative;
              z-index: 1;
            }
            &::before {
              content: "";
              position: absolute;
              background: url(../assets/imgs/official_icon.png) no-repeat;
              background-size: 80%;
              width: 199px;
              height: 171px;
              right: -75px;
              bottom: -55px;
              filter: grayscale(100%) brightness(300%);
              opacity: 0.2;
            }
            .more {
              padding: 48px;
              font-weight: normal;
              .msg {
                color: #fff;
                font-size: 16px;
                line-height: 1.7;
              }
              .button {
                position: relative;
                z-index: 1;
                background: #fff;
                padding: 8px;
                font-size: 16px;
                color: #437acf;
                margin-top: 36px;
                border-radius: 5px;
                cursor: pointer;
                font-weight: bold;
              }
            }
          }
          &:hover {
            .hover {
              top: 0px;
            }
          }
        }
      }
    }
    &::before {
      content: "";
      position: absolute;
      background: url(../assets/imgs/img_back.png) no-repeat;
      width: 896px;
      height: 372px;
      left: 152px;
      top: 145px;
    }
  }
}
.overview_wrap {
  min-width: 1200px;
  background: #fff;
  .wrap {
    padding: 86px 0;
    position: relative;
    .content {
      width: 100%;
      text-align: center;
      .title {
        margin-bottom: 60px;
      }
    }
  }
}
</style>